import useT from "utils/useT"
import useGlobalStore from "stores/global"
import useUnsavedStore from "stores/unsaved"
import useRouterStore from "stores/routerStore"

const LanguagePicker = () => {
  const push = useRouterStore((state) => state.router?.push)
  const pathname = useRouterStore((state) => state.router?.pathname)
  const setLanguage = useGlobalStore((state) => state.setLanguage)
  const toggleLanguageSheet = useUnsavedStore(
    (state) => state.toggleLanguageSheet,
  )
  const t = useT()
  const changeLanguage = (locale: "en" | "ar" | "tr-TR") => {
    setLanguage(locale)
    toggleLanguageSheet()
    pathname && push?.(pathname, {}, { locale })
  }
  return (
    <div className="pe-3 ps-3 pt-3">
      <h3 dir="auto" className="font-700 mb-2 font-25">
        {t.settings.selectLanguage}
      </h3>
      <div className="list-group list-custom-small">
        <a onClick={() => changeLanguage("en")}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            className="me-3 mt-n1"
            width="20"
            src="/flags/uk.svg"
            alt="english language"
          />
          <span>English</span>
          <i className="fa fa-angle-right"></i>
        </a>
        <a onClick={() => changeLanguage("ar")}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            className="me-3 mt-n1"
            width="20"
            src="/flags/iq.svg"
            alt="arabic language"
          />
          <span>العربية</span>
          <i className="fa fa-angle-right"></i>
        </a>
        <a onClick={() => changeLanguage("tr-TR")}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            className="me-3 mt-n1"
            width="20"
            src="/flags/tr.svg"
            alt="turkish language"
          />
          <span>Türkçe</span>
          <i className="fa fa-angle-right"></i>
        </a>
      </div>
    </div>
  )
}

export default LanguagePicker
